import { h } from "preact";
import { GlobalsContext } from "../../AppContext";
import { useContext } from "preact/hooks";
import style from "./CloseButton.css";
import clsx from "clsx";

const CloseButton = () => {
    const { widgetOpen, setWidgetOpen } = useContext(GlobalsContext);

    const handleCloseClick = (e) => {
        e.stopPropagation();
        setWidgetOpen(false);
    };

    return (
        <div
            className={clsx(style.root, widgetOpen ? style.open : style.minimized)}
            onClick={ handleCloseClick }
        />
    );
};

export default CloseButton;
